module.exports = __webpack_public_path__ + "media/images/emoticons/gawk-5645b435de88be11a73b039fd23a8caa.gif";